import React, { useState, useReducer } from 'react';
import '../../common/styles/rightSide.css';
import { useForm } from 'react-hook-form';
import produce from 'immer';
import { graphTypes } from '../../constants/graphTypes';
import { InputLabel, FormControl } from '@material-ui/core';

import Amplitude2D from '../graphs/Amplitude2D';
import Amplitude1D from '../graphs/Amplitude1D';
import EventFreqGraph from '../graphs/EventFreqGraph';
import EventSpaceGraph from '../graphs/EventSpaceGraph';
import TempCorrGraph from '../graphs/TempCorrGraph';
import CorrDistGraph from '../graphs/CorrDistGraph';
import GalaxyGraph from '../graphs/GalaxyGraph';
import TemporalWidthGraph from '../graphs/TemporalWidthGraph';
import WidthDistGraph from '../graphs/WidthDistGraph';
import { graphReducer } from '../../../reducers/graphReducer';
import useFetchDdpcr2DGraphData from '../../Hooks/qlp_ddpcr/useFetchDdpcr2DGraphData';
import useFetchDdpcr1DGraphData from '../../Hooks/qlp_ddpcr/useFetchDdpcr1DGraphData';
import useFetchEventFreqGraphData from '../../Hooks/qlp_ddpcr/useFetchEventFreqGraphData';
import useFetchEventSpaceGraphData from '../../Hooks/qlp_ddpcr/useFetchEventSpaceGraphData';
import useFetchTempCorrGraphData from '../../Hooks/qlp_ddpcr/useFetchTempCorrGraphData';
import useFetchCorrDistGraphData from '../../Hooks/qlp_ddpcr/useFetchCorrDistGraphData';
import useFetchGalaxyGraphData from '../../Hooks/qlp_ddpcr/useFetchGalaxyGraphData';
import useFetchTemporalWidthGraphData from '../../Hooks/qlp_ddpcr/useFetchTemporalWidthGraphData';
import useFetchWidthDistGraphData from '../../Hooks/qlp_ddpcr/useFetchWidthDistGraphData';
import { detectChannels } from '../graphs/common/utils';

import { makeStyles } from '@material-ui/core/styles';
import GraphSelect from '../GraphSelect';
const useStyles = makeStyles(theme => ({}));

const initialState = {
  graphType: 'Amplitude 1D',
  amplitude2D: false,
  amplitude1D: true,
};

const curryiedGraphReducer = produce(graphReducer);
const RightSide = plateWell => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
  } = useForm();

  const initalizeStateLazily = () => ({
    graphType: 'Amplitude 1D',
    amplitude1D: true,
  });

  const [state, dispatch] = useReducer(curryiedGraphReducer, initialState, initalizeStateLazily);

  //temporary till

  const [data2d, set2dData] = useState(null);
  const [data1d, set1dData] = useState(null);

  const { amplitude2D, amplitude1D, graphType } = state;
  const classes = useStyles();

  // This section will fetch all the graph data for each graphs

  const graph2dData = useFetchDdpcr2DGraphData(plateWell.plateWell);
  const graph1dData = useFetchDdpcr1DGraphData(plateWell.plateWell);
  const eventFreqData = useFetchEventFreqGraphData(plateWell.plateWell);
  const eventSpaceData = useFetchEventSpaceGraphData(plateWell.plateWell);
  const tempCorrData = useFetchTempCorrGraphData(plateWell.plateWell);
  const corrDistData = useFetchCorrDistGraphData(plateWell.plateWell);
  const galaxyData = useFetchGalaxyGraphData(plateWell.plateWell);
  const temporalWidthData = useFetchTemporalWidthGraphData(plateWell.plateWell);
  const widthDistData = useFetchWidthDistGraphData(plateWell.plateWell);

  // Detect active channels from whichever dataset resolves first
  const activeChannels = detectChannels(graph1dData?.data ?? graph2dData?.data ?? []);

  const handleSelectedGraph = e => {
    switch (e.target.value) {
      case 'Amplitude 2D':
        dispatch({ type: 'Amplitude2D', amplitude2D: true, graphType: 'Amplitude 2D' });
        break;
      case 'Amplitude 1D':
        dispatch({ type: 'Amplitude1D', amplitude1D: true, graphType: 'Amplitude 1D' });
        break;
      case 'Event Frequency':
        dispatch({ type: 'EventFreq' });
        break;
      case 'Event Spacing Distribution':
        dispatch({ type: 'EventSpace' });
        break;
      case 'Temporal Correlation':
        dispatch({ type: 'TempCorr' });
        break;
      case 'Correlation Distribution ':
        dispatch({ type: 'CorrDist' });
        break;
      case 'Galaxy':
        dispatch({ type: 'Galaxy' });
        break;
      case 'Temporal Width':
        dispatch({ type: 'TemporalWidth' });
        break;
      case 'Width Distribution':
        dispatch({ type: 'WidthDist' });
        break;
      default:
        return null;
    }
  };

  const onSubmit = values => {
    console.log(values);
  };
  return (
    <>
      <div className="graphContainer">
        <aside>
          <form>
            <FormControl fullWidth variant="outlined" className={classes.formControl}>
              <InputLabel id="demo-simple-select-label">Select Graph</InputLabel>

              {/* <Controller control={control}
                        name="graph"
                        id="graph_id"
                        render={({ field }) => ( */}
              <GraphSelect
                graph={graphTypes}
                onSelect={handleSelectedGraph}
                defaultValue={graphType}
                //        {...field}
              />
            </FormControl>
            {/* <Button type="submit">Submit</Button> */}
          </form>
        </aside>

        <main>
          {(() => {
            // Graphs return either a list payload (1D/2D/Galaxy/Temporal Width/…)
            // or an object payload ({x, y} / {x, y_accepted, y_excluded}) for the
            // histogram/line graphs (Event Freq/Space, Correlation Dist). A skipped
            // graph is written as "[]" (empty array). Treat all of those as "no data".
            const noData = q => {
              if (!q?.isSuccess) return false;
              const d = q?.data;
              if (Array.isArray(d)) return d.length === 0;
              if (d && typeof d === 'object') return !d.x?.length;
              return true;
            };
            const unavailable = (
              <p style={{ color: '#e57373', padding: '1rem' }}>
                Graph data unavailable — re-drive ingestion to regenerate.
              </p>
            );

            switch (true) {
              case amplitude2D:
                return graph2dData?.isFetching ? (
                  <p>Fetching data points.. please wait</p>
                ) : noData(graph2dData) || graph2dData?.isError ? (
                  unavailable
                ) : graph2dData?.isSuccess ? (
                  <Amplitude2D graphData={graph2dData.data} activeChannels={activeChannels} />
                ) : (
                  'Unknown Error..'
                );

              case amplitude1D:
                return graph1dData?.isFetching ? (
                  <p>Fetching data points.. please wait</p>
                ) : noData(graph1dData) || graph1dData?.isError ? (
                  unavailable
                ) : graph1dData?.isSuccess ? (
                  <Amplitude1D graphData={graph1dData.data} activeChannels={activeChannels} />
                ) : (
                  'Unknown Error..'
                );

              case graphType === 'Event Frequency':
                return eventFreqData?.isFetching ? (
                  <p>Fetching data points.. please wait</p>
                ) : noData(eventFreqData) || eventFreqData?.isError ? (
                  unavailable
                ) : eventFreqData?.isSuccess ? (
                  <EventFreqGraph graphData={eventFreqData.data} />
                ) : (
                  'Unknown Error..'
                );

              case graphType === 'Event Spacing Distribution':
                return eventSpaceData?.isFetching ? (
                  <p>Fetching data points.. please wait</p>
                ) : noData(eventSpaceData) || eventSpaceData?.isError ? (
                  unavailable
                ) : eventSpaceData?.isSuccess ? (
                  <EventSpaceGraph graphData={eventSpaceData.data} />
                ) : (
                  'Unknown Error..'
                );

              case graphType === 'Temporal Correlation':
                return tempCorrData?.isFetching ? (
                  <p>Fetching data points.. please wait</p>
                ) : noData(tempCorrData) || tempCorrData?.isError ? (
                  unavailable
                ) : tempCorrData?.isSuccess ? (
                  <TempCorrGraph graphData={tempCorrData.data} />
                ) : (
                  'Unknown Error..'
                );

              case graphType === 'Correlation Distribution ':
                return corrDistData?.isFetching ? (
                  <p>Fetching data points.. please wait</p>
                ) : noData(corrDistData) || corrDistData?.isError ? (
                  unavailable
                ) : corrDistData?.isSuccess ? (
                  <CorrDistGraph graphData={corrDistData.data} />
                ) : (
                  'Unknown Error..'
                );

              case graphType === 'Galaxy':
                return galaxyData?.isFetching ? (
                  <p>Fetching data points.. please wait</p>
                ) : noData(galaxyData) || galaxyData?.isError ? (
                  unavailable
                ) : galaxyData?.isSuccess ? (
                  <GalaxyGraph graphData={galaxyData.data} />
                ) : (
                  'Unknown Error..'
                );

              case graphType === 'Temporal Width':
                return temporalWidthData?.isFetching ? (
                  <p>Fetching data points.. please wait</p>
                ) : noData(temporalWidthData) || temporalWidthData?.isError ? (
                  unavailable
                ) : temporalWidthData?.isSuccess ? (
                  <TemporalWidthGraph graphData={temporalWidthData.data} />
                ) : (
                  'Unknown Error..'
                );

              case graphType === 'Width Distribution':
                return widthDistData?.isFetching ? (
                  <p>Fetching data points.. please wait</p>
                ) : noData(widthDistData) || widthDistData?.isError ? (
                  unavailable
                ) : widthDistData?.isSuccess ? (
                  <WidthDistGraph graphData={widthDistData.data} />
                ) : (
                  'Unknown Error..'
                );

              default:
                return null;
            }
          })()}
        </main>
      </div>
    </>
  );
};
RightSide.whyDidYouRender = true;

export default RightSide;
